import React from "react";
import "./FooterSection.css";

export default function FooterSection() {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        © 2025 FIND YOUR PEAK. ALL RIGHTS RESERVED.
      </div>
    </footer>
  );
} 